import { Avatar, Box, IconButton, Typography } from "@mui/material"
import { useState } from "react"
import CustomButton from "../../../components/CustomButton"
import AddEventPopup from "./AddEventPopup"
import CustomCard from "./CustomCard"
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import MoreHorizOutlinedIcon from '@mui/icons-material/MoreHorizOutlined';
import { useSelector } from "react-redux"
import "@fontsource/rubik";
import CustomTooltip from "../../../components/CustomTooltip"
import { getInitials } from "../../../utils/commonServices"
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import { customTheme as theme } from "../../../theme/customTheme"
import useCustomTheme from "../../../theme/useCustomTheme"


const CollaboratorCard = (props) => {

    const [open, setOpen] = useState(false)
    const { shareClickHandler, copyInvite, setButtonText, eventCode, buttonState = 'copy invitation', isDisabled = false }= props
    const commonReducer = useSelector((state) => state.root.commonReducer);
    const [theme ] = useCustomTheme()

    const addEventOpenHandler = ()=>{
        setOpen(true)
    }

  

  return (
    <CustomCard   style={{ height:'100%', opacity:( isDisabled || (commonReducer.user_name != commonReducer.event_details?.owner_name)) && 0.5 }} >

        <Box sx={{paddingLeft:{xs:'10px' , sm:'15px',md:'18px',lg:'23px',xl:'30px'}, display:'flex', flexDirection:'column', justifyContent:'center', height:'100%', width:'100%',  paddingTop: {xs:'5px',sm:'5px',md:'9px', lg:'12px', xl:'21px'}, paddingBottom: {xs:'5px',sm:'5px',md:'13px', lg:'12px', xl:'21px'}, paddingRight:{xs:'10px' , sm:'15px',md:'18px',lg:'23px',xl:'30px'},}} gap={0.5}>

         <Box flex={1} sx={{gap:0}}>
            <Box  sx={{display:'flex', alignItems:'center', justifyContent:'space-between'}}>
                <Typography sx={{fontSize:{xs:'10px',md:'10px',lg:'11px',xl:'16px'}, color:'#000000', fontFamily:'Rubik'}}>Project Owner</Typography>
                <IconButton disabled={isDisabled  || (commonReducer.user_name != commonReducer.event_details?.owner_name)} >
                  <MoreHorizOutlinedIcon sx={{fontSize:{xs:'13px',md:'14px',lg:'16px',xl:'16px'}, color:'#08231B'}}/>
                </IconButton>
            </Box>
            <Avatar sx={{borderRadius:'5px', backgroundColor:theme.palette.primary.main, color:'white',width:{xs:'18px',sm:'20px' ,md:'22px' , lg:'23.5px' ,xl:'35px'}, height:{xs:'18px',sm:'20px' ,md:'22px' , lg:'23.5px' ,xl:'35px'}, paddingRight:0, marginRight:0,  fontSize:{xs:'7px',md:'8px',lg:'8px',xl:'12px'}, textTransform:'uppercase', fontFamily:'Rubik'}}>{getInitials(commonReducer?.event_details?.owner_name)}</Avatar>
         </Box>
         <Box flex={1} sx={{display:'flex', flexDirection:'column',  }} gap={{xs:'4px',md:'6px',lg:'6px',xl:'12px'}}>
            <Typography sx={{fontSize:{xs:'10px',md:'10px',lg:'11px',xl:'16px'}, color:'#000000', fontFamily:'Rubik'}}>Project Collaborator</Typography>
            <Box sx={{display:'flex'}} gap={{xs:'5px',sm:'7px',md:'9px',lg:'10px',xl:'15px'}}>
                {/* <Avatar sx={{borderRadius:'5px', backgroundColor:'#6C00FF', color:'white',width:{xs:'18px',sm:'20px' ,md:'22px' , lg:'24px' ,xl:'35px'}, height:{xs:'18px',sm:'20px' ,md:'22px' , lg:'24px' ,xl:'35px'}, paddingRight:0, marginRight:0,  fontSize:{xs:'7px',md:'8px',lg:'8px',xl:'12px'}}}>DB</Avatar> */}
              {/* <CustomTooltip title='Only project owner is authorized' sx={{display:commonReducer.user_name == commonReducer.event_details?.owner_name && 'none' }}> */}
              
                <Typography sx={{display: isDisabled && 'none', fontSize:{xs:'12px',md:'13px',lg:'14px',xl:'18px'}, fontFamily:'Rubik', fontWeight:600}} >{eventCode}<span><CustomTooltip onClose = {()=> setButtonText('copy invitation')}  title={commonReducer.user_name == commonReducer.event_details?.owner_name ? buttonState : 'Only project owner is authorized'} ><ContentCopyIcon onClick= { (!isDisabled || commonReducer.user_name == commonReducer.event_details?.owner_name) && copyInvite}  sx={{ ml: '4px', fontSize: "12px !important", fontWeight: 800, cursor: commonReducer.user_name == commonReducer.event_details?.owner_name && 'pointer'}}/></CustomTooltip></span></Typography>
                <span>
               {/* <CustomButton 
                 disabled={isDisabled  || (commonReducer.user_name != commonReducer.event_details?.owner_name)}
                 btnText={buttonState}
                 // startIcon={<AddOutlinedIcon sx={{fontSize:''}}/>}  
                 variant='contained' onClick={copyInvite} style={{borderRadius: '5px', backgroundColor:'#08231B', color:theme.palette.primary.main, textTransform:'none', }} sx={{height:{xs:'18px',sm:'20px',md:'22px', lg:'23px', xl:'35px'}, width:{xs:'130px', lg:'150px',xl:'220px'}, fontSize:{xs:'10px',md:'10px',lg:'11px',xl:'16px'}, fontFamily:'Rubik', fontWeight:600}}
                /> */}
                </span>
                {/* </CustomTooltip> */}
            </Box>
         </Box>
      
        {open && <AddEventPopup open={open} setOpen={setOpen}/>}

        
        </Box>
    </CustomCard>
  )
}

export default CollaboratorCard